import { render, staticRenderFns } from "./tabResponsible.vue?vue&type=template&id=214e469c&scoped=true&"
import script from "./tabResponsible.vue?vue&type=script&lang=js&"
export * from "./tabResponsible.vue?vue&type=script&lang=js&"
import style0 from "./tabResponsible.vue?vue&type=style&index=0&id=214e469c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e469c",
  null
  
)

export default component.exports